import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import SettingManager from "../../components/pageManager/SettingManager";

const SettingsPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <SettingManager />
                </div>
            </div>
        </div>
    );
};

export default SettingsPage;
